import React from 'react';
import { Reveal } from '../Reveal';
import { useLanguage } from '../../contexts/LanguageContext';
export function SocialProof() {
  const {
    t
  } = useLanguage();
  return <section className="bg-white py-20 sm:py-24" aria-label={t.socialProof.sectionLabel} data-id="element-268" data-mp="dcpd8qx2ztzu">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-269" data-mp="dacn3qh66dbp">
        <Reveal data-id="element-270" data-mp="8ct9mssaq4kt">
          <p className="text-center text-[12px] font-semibold uppercase tracking-[0.2em] text-ink/40" data-id="element-271" data-mp="8dcf3a0rf0hy">
            {t.socialProof.eyebrow}
          </p>
        </Reveal>
        <dl className="mt-14 grid grid-cols-2 gap-y-12 sm:gap-y-14 lg:grid-cols-4" data-id="element-272" data-mp="3ujrgfj43uvzj">
          {t.socialProof.metrics.map((metric, i) => <Reveal key={metric.label} delay={i * 0.08} data-id="element-273" data-mp="3qjhcebzvifnb" data-mpi={i}>
              <div className="px-2 text-center lg:border-r lg:border-ink/10 lg:last:border-r-0" data-id="element-274" data-mp="3lkwam84z3nwr">
                <dt className="sr-only" data-id="element-275" data-mp="1osdwp8b4mavw">{metric.label}</dt>
                <dd data-id="element-276" data-mp="1oprpxaw27zeq">
                  <span className="block text-[34px] font-bold leading-none tracking-tight text-ink sm:text-[44px]" data-id="element-277" data-mp="1jt12u3lu83jt">
                    {metric.value}
                  </span>
                  <span className="mt-3 block text-[13px] font-medium text-ink/55 sm:text-[14px]" data-id="element-278" data-mp="1tavcfkiddok7">
                    {metric.label}
                  </span>
                </dd>
              </div>
            </Reveal>)}
        </dl>
      </div>
    </section>;
}